import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, shallowRef } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SvVideoPlayer',
  props: {
    src: {}
  },
  setup(__props: any) {



const fullscreen = ref<boolean>(false);
const player = shallowRef();

const handleMounted = (payload: any) => {
  player.value = payload.player;
  player.value?.play();
};

const handleFullscreenChanged = () => {
  fullscreen.value = !fullscreen.value;
};

const handleFullscreen = () => {
  player.value?.requestFullscreen();
};

return (_ctx: any,_cache: any) => {
  const _component_vue_video_player = _resolveComponent("vue-video-player")!

  return (_openBlock(), _createBlock(_component_vue_video_player, {
    class: "video-player vjs-big-play-centered",
    src: _ctx.src,
    loop: true,
    muted: !fullscreen.value,
    controls: fullscreen.value,
    playsinline: "",
    disablePictureInPicture: "",
    crossorigin: "anonymous",
    onMounted: _cache[0] || (_cache[0] = ($event: any) => (handleMounted($event))),
    onFullscreenchange: handleFullscreenChanged,
    onClick: handleFullscreen
  }, null, 8, ["src", "muted", "controls"]))
}
}

})